import theme from '../theme'
import { makeStyles } from '@material-ui/core'
import { styled, StyledComponentProps } from '@material-ui/core/styles'
import { ComponentType, ElementType } from 'react'

export const customClasses = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    '&.clicked': {
      outline: '1px solid' + theme.palette.purple.main,
    },
    '& button': {
      width: '20%',
      border: '1px solid ' + theme.palette.grey[500],
      '&.minus': {
        borderTopLeftRadius: theme.shape.borderRadius + ' !important',
        borderBottomLeftRadius: theme.shape.borderRadius + ' !important',
        borderTopRightRadius: 0 + ' !important',
        borderBottomRightRadius: 0 + ' !important',
      },
      '&.plus': {
        borderTopRightRadius: theme.shape.borderRadius + ' !important',
        borderBottomRightRadius: theme.shape.borderRadius + ' !important',
        borderTopLeftRadius: 0 + ' !important',
        borderBottomLeftRadius: 0 + ' !important',
      },
    },
    '& input': {
      width: '60%',
      height: '40px',
      borderLeft: 'none',
      borderRight: 'none',
      borderBottom: '1px solid ' + theme.palette.grey[500],
      borderTop: '1px solid ' + theme.palette.grey[500],
      textAlign: 'center',
      '&[type=number]': {
        '-moz-appearance': 'textfield',
        '&[disabled]': {
          borderBottom: '1px solid ' + theme.palette.grey[200],
          borderTop: '1px solid ' + theme.palette.grey[200],
          backgroundColor: 'white',
        },
      },
      '&::-webkit-outer-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      '&::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      '&:focus': {
        outline: 'transparent',
        border: '1px solid ' + theme.palette.primary.main,
      },
    },
  },
  icons: {
    width: '20px !important',
    height: '20px !important',
  },
})
